import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import About from './Pages/About';
import ShopCategory from './Pages/ShopCategory';
import Cart from './Pages/Cart';
import LoginSignup from './Pages/LoginSignup';
import Footer from './Components/Footer/Footer';
import Home from './Pages/LandingPage';
import Contact from './Pages/Contact';
import Header from './Components/Header/Header';
import PaypalSuccess from './Components/Paypal/PaypalSuccess';
import { Elements } from '@stripe/react-stripe-js';  
import { loadStripe } from '@stripe/stripe-js';  


// Conditionally load Stripe keys based on the environment
const stripePromise = loadStripe(
  process.env.REACT_APP_NODE_ENV === 'production' 
  ? process.env.REACT_APP_STRIPE_PUBLIC_KEY_LIVE  // Live key
  : process.env.REACT_APP_STRIPE_PUBLIC_KEY_TEST  // Test key
);


function App() {

   // Log the environment to the console
   const environment = process.env.REACT_APP_NODE_ENV;
   console.log(`App is running in ${environment} mode`);
   
  return (
    <BrowserRouter>
     <Elements stripe={stripePromise}>
      <AppRoutes />
      </Elements>
    </BrowserRouter>
  );
}

function AppRoutes() {
  const location = useLocation(); // Get the current route location

  // Check if the current route is the landing page
  const isLandingPage = location.pathname === '/';
  const isAboutPage = location.pathname === '/about';
  const isContactPage = location.pathname === '/contact';

  return (
    <div>
      <Navbar />
      {/* Conditionally render the Header based on the current route */}
      {!isLandingPage && !isAboutPage && !isContactPage && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* Updated category paths reusing existing banners */}
        <Route
          path="/living-room"
          element={<ShopCategory category="living-room" />}
        />
        <Route
          path="/dining-room"
          element={<ShopCategory category="dining-room" />}
        />
        <Route
          path="/foyer"
          element={<ShopCategory category="foyer" />}
        />
        <Route
          path="/bedroom"
          element={<ShopCategory category="bedroom" />}
        />
        <Route
          path="/office"
          element={<ShopCategory category="office" />}
        />
        <Route
          path="/children"
          element={<ShopCategory category="children" />}
        />
        <Route
          path="/home-decor"
          element={<ShopCategory category="home-decor" />}
        />
        <Route
          path="/textiles"
          element={<ShopCategory category="textiles" />}
        />
        <Route
          path="/accents"
          element={<ShopCategory category="accents" />}
        />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<LoginSignup />} />
        <Route path="/success" element={<PaypalSuccess />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
